import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
    namespaced: true,
    // here the state needs to be a function to be able to reuse this module.
    state: () => state,
    getters,
    mutations,
    actions
};
